<div class="modal-header">
  <div class="d-flex align-items-center gap-2 flex-1">
    <h6 class="modal-title" i18n>Autopilot Wizard</h6>
    <app-page-help [articleId]="articleId" videoId="-"></app-page-help>
  </div>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<ng-container [ngSwitch]="activeStep">
  <ng-template *ngSwitchCase="1" [ngTemplateOutlet]="step1"></ng-template>
  <ng-template *ngSwitchCase="2" [ngTemplateOutlet]="step2"></ng-template>
</ng-container>

<ng-template #step1>
  <div class="modal-body bg-none p-0">
    <div class="alert alert-secondary-info">
      <ng-container i18n
        >The Autopilot Wizard is here to help you effortlessly automate your short-term rental operations. Simply choose
        what you’d like to streamline—like bookings, payments, or messages—and set up automations that save you time and
        keep everything running smoothly in just a few clicks.</ng-container
      >
    </div>

    <h6 i18n>What would you like to automate?</h6>
    <div class="select-block-container">
      <div
        class="select-block"
        [class.active]="automationType === item.type"
        *ngFor="let item of automationTypesConfig"
        [matTooltip]="item.tooltip"
      >
        <a (click)="onChangeAutomationType(item.type)">
          <i [ngClass]="item.icon + ' ' + item.color"></i>
          <div class="text-nowrap">{{ item.label }}</div>
        </a>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" [disabled]="!automationType" (click)="activeStep = activeStep + 1">
      <ng-container i18n>Next</ng-container>
      <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
    </button>
  </div>
</ng-template>

<ng-template #step2>
  <div class="modal-body bg-none p-0">
    <ng-container [ngSwitch]="automationType">
      <app-rate-automation-wizard
        *ngSwitchCase="automationTypes.Rate"
        (typeChange)="automationType = $event"
      ></app-rate-automation-wizard>
      <app-booking-automation-wizard
        *ngSwitchCase="automationTypes.Booking"
        (typeChange)="automationType = $event"
      ></app-booking-automation-wizard>
      <app-document-automation-wizard
        *ngSwitchCase="automationTypes.Document"
        (typeChange)="automationType = $event"
      ></app-document-automation-wizard>
      <app-expense-automation-wizard
        *ngSwitchCase="automationTypes.Expense"
        (typeChange)="automationType = $event"
      ></app-expense-automation-wizard>
      <app-invoice-automation-wizard
        *ngSwitchCase="automationTypes.Invoice"
        (typeChange)="automationType = $event"
      ></app-invoice-automation-wizard>
      <app-message-automation-wizard
        *ngSwitchCase="automationTypes.Message"
        (typeChange)="automationType = $event"
      ></app-message-automation-wizard>
      <app-review-automation-wizard
        *ngSwitchCase="automationTypes.Review"
        (typeChange)="automationType = $event"
      ></app-review-automation-wizard>
      <app-task-automation-wizard
        *ngSwitchCase="automationTypes.Task"
        (typeChange)="automationType = $event"
      ></app-task-automation-wizard>
      <app-card-automation-wizard
        *ngSwitchCase="automationTypes.CreditCard"
        (typeChange)="automationType = $event"
      ></app-card-automation-wizard>
      <app-charge-automation-wizard
        *ngSwitchCase="automationTypes.Charge"
        (typeChange)="automationType = $event"
      ></app-charge-automation-wizard>
      <app-extra-automation-wizard
        *ngSwitchCase="automationTypes.Extra"
        (typeChange)="automationType = $event"
      ></app-extra-automation-wizard>
      <app-guest-automation-wizard
        *ngSwitchCase="automationTypes.Guest"
        (typeChange)="automationType = $event"
      ></app-guest-automation-wizard>
      <app-lock-automation-wizard
        *ngSwitchCase="automationTypes.Device"
        (typeChange)="automationType = $event"
      ></app-lock-automation-wizard>
      <app-incident-automation-wizard
        *ngSwitchCase="automationTypes.Incident"
        (typeChange)="automationType = $event"
      ></app-incident-automation-wizard>
      <app-inventory-automation-wizard
        *ngSwitchCase="automationTypes.Inventory"
        (typeChange)="automationType = $event"
      ></app-inventory-automation-wizard>
      <app-security-deposit-automation-wizard
        *ngSwitchCase="automationTypes.SecurityDeposit"
        (typeChange)="automationType = $event"
      ></app-security-deposit-automation-wizard>
    </ng-container>
  </div>
  <div class="modal-footer">
    <button class="btn btn-light" (click)="onPrevType()">
      <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i> <ng-container i18n>Previous</ng-container>
    </button>
    <button class="btn btn-light" (click)="onNextType()">
      <ng-container i18n>Next</ng-container>
      <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
    </button>
    <button class="btn btn-light" (click)="close()">
      <i class="far fa-times"></i>
      <ng-container i18n>Cancel</ng-container>
    </button>
    <button class="btn btn-secondary-info" (click)="onSave()">
      <i class="cs-icon cs-icon-save"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
</ng-template>
